import { socket } from '../api/config';

export default {
  getCarBrands: () => {
    const query = JSON.stringify({
      message: `{
                carBrands {
                    name
                    key
                    popular
                    isSelected
                  }
            }`,
      queryName: 'carBrands',
    });
    socket.emit('graphql', query);
  },
  selectCarBrand: (messageId, brandKey, text, dialog_id, buyerId, message_uuid) => {
    const input = {
      text,
      message_uuid,
      dialog_id
    };

    const brandSelectionInput = {
      brandKey,
      messageId,
    };

    const variables = {
      input,
      brandSelectionInput,
      buyerId,
    };

    const query = {
      message: `mutation($input: MessageInput, $brandSelectionInput: BrandSelectionInput, $buyerId: Int!) {
        message: selectBuyerCarBrand(input: $input, brandSelectionInput: $brandSelectionInput, buyerId: $buyerId) {
          message_id
          dialog_id
          timestamp
          timestamp_received
          is_read
          is_delivered
          content
          message_uuid
          sender {
              sender_id
              name
              picture_path
              type_id
          }
        }
      }`,
      variables,
      queryName: 'addMessage',
    };

    socket.emit('graphql', query);
  },
};
